import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useDispatch, useSelector } from "react-redux";
import { loadMyBookingGetDataRequest, loadSeatBookingCancelDataRequest } from "../redux/Actions";
import { Modal, Button } from "react-bootstrap";
import "./calender.css";

const MyReservationsCalendar = ({ onEventClick }) => {
  const dispatch = useDispatch();
  const { mybookings } = useSelector((state) => state.seatBooking);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const { cancelBookingSuccess } = useSelector(state => state.seatBooking);

    useEffect(() => {
    if (cancelBookingSuccess) {
        setShowCancelModal(false);
        dispatch(loadMyBookingGetDataRequest());
    }
    }, [cancelBookingSuccess, dispatch]);


  useEffect(() => {
    dispatch(loadMyBookingGetDataRequest());
  }, [dispatch]);

  const events = (mybookings || []).map((b) => ({
    id: b.reservation_id,
    title: `Flex Room ${b.room?.split("-")[1]}\n${b.seat_number}`,
    start: b.reservation_date.split("T")[0],
    allDay: true,
    extendedProps: b,
  }));

  // Show modal when trash icon is clicked
  const handleTrashClick = (reservationId) => {
    setSelectedReservationId(reservationId);
    setShowCancelModal(true);
  };

  // Confirm cancel
  const handleConfirmCancel = () => {
    dispatch(loadSeatBookingCancelDataRequest(selectedReservationId))        
  };


  return (
    <>
      <div className="my-calendar-wrapper">
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev,today,next",
           // center: "today",
            right: "title",
          }}
          buttonText={{ today: "Today" }}
          events={events}
          height="auto"
          dayMaxEvents={2}
          eventContent={(eventInfo) => (
            <div className="fc-event-custom">
              <div className="fc-event-text">
                {eventInfo.event.title.split("\n").map((line, i) => (
                  <div key={i}>{line}</div>
                ))}
              </div>
              <span
                className="fc-event-trash"
                onClick={(e) => {
                  e.stopPropagation(); // prevent eventClick
                  handleTrashClick(eventInfo.event.id);
                }}
              >
                🗑
              </span>
            </div>
          )}
        />
      </div>

      {/* Cancel Reservation Modal */}
      <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Reservation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to cancel this reservation?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleConfirmCancel}>
            Yes, Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MyReservationsCalendar;
